import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../theme';

/**
 * Custom hook that defines the styles for the side bar nav component.
 */
const useSideBarNavStyles = makeStyles()(() => ({
  sideBarNav: {
    position: 'absolute',
    right: 0,
    display: 'flex',
    flexDirection: 'column',
    minWidth: '220px',
    maxWidth: '220px',
    alignItems: 'center',
    height: 'calc(100vh - 100px)',
    background: 'white',
    zIndex: 4,
    justifyContent: 'space-between',
    padding: `${theme.padding.m} 0`,
  },
  sideBarNavOptions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    alignItems: 'center',
  },
  menuButton: {
    'display': 'flex',
    'flexDirection': 'row',
    'justifyContent': 'flex-start',
    'alignItems': 'center',
    'textWrap': 'nowrap',
    'textDecoration': 'none',
    'gap': theme.margin.s,
    'padding': `${theme.padding.xs} ${theme.padding.m} ${theme.padding.xs} ${theme.padding.m}`,
    'fontFamily': theme.fontFamily,
    'fontSize': theme.fontSize.default,
    'fontWeight': theme.fontWeight.medium,
    'height': '40px',
    'maxWidth': '60%',
    'minWidth': '60%',
    'marginTop': theme.margin.m,
    'marginRight': theme.margin.xs,
    'borderRadius': theme.borderRadius.s,
    'textAlign': 'center',
    'lineHeight': '40px',
    'color': theme.primary.light,
    '&:first-of-type': {
      marginTop: '0',
    },
    '&:hover': {
      color: theme.primary.light,
      backgroundColor: colors.gray['200'],
    },
    '&:active': {
      color: theme.primary.lighter,
      backgroundColor: theme.background.lighter,
      boxShadow: theme.buttonShadow(theme.background.lighter),
    },
  },
  logoutButton: {
    'color': colors.red['500'],
    '&:hover': {
      color: colors.red['500'],
    },
    '&:active': {
      color: colors.red['500'],
    },
  },
  menuSelected: {
    'background': theme.background.light,
    '&:hover': {
      color: theme.primary.light,
      backgroundColor: theme.background.light,
    },
    '&: active': {
      color: theme.primary.light,
    },
  },
}));

export default useSideBarNavStyles;
